import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import DisplayText, { TextVariant } from "./DisplayText";
import clsx from "clsx";
var useGroupStyles = createUseStyles({
    horizontal: {
        display: "flex",
        justifyContent: "space-around"
    }
});
var RadioGroup = function (props) {
    var _a, _b;
    var _c = useState(props.value), value = _c[0], setValue = _c[1];
    var horizontal = (_a = props.horizontal) !== null && _a !== void 0 ? _a : false;
    var disabled = (_b = props.disabled) !== null && _b !== void 0 ? _b : false;
    var classes = useGroupStyles();
    var handleChange = function (event) {
        setValue(event.target.value);
        if (props.onChange) {
            props.onChange(event);
        }
    };
    return (React.createElement("div", { className: clsx(props.className, horizontal && classes.horizontal) }, React.Children.map(props.children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                disabled: disabled,
                name: props.name,
                checked: value === child.props.value,
                onChange: handleChange
            });
        }
        return child;
    })));
};
var useRadioStyles = createUseStyles(function (theme) { return ({
    label: {
        display: "block",
        position: "relative",
        paddingLeft: 35,
        marginBottom: 12,
        cursor: function (props) { return props.disabled ? "default" : "pointer"; },
        userSelect: "none",
        "&:hover $radioButton": {
            backgroundColor: function (props) { return props.disabled ? "none" : "#ccc"; }
        },
    },
    input: {
        position: "absolute",
        opacity: 0,
        cursor: function (props) { return props.disabled ? "default" : "pointer"; },
        top: 0,
        left: 0
    },
    radioButton: {
        position: "absolute",
        top: 0,
        left: 0,
        height: 24,
        width: 24,
        backgroundColor: "white",
        borderRadius: "50%",
        border: function (props) { return "solid 1px ".concat(props.disabled ? "#AAAAAA" : theme.color.primary.main); },
        "&:after": {
            top: function (props) { return props.checked ? 3 : 12; },
            left: function (props) { return props.checked ? 3 : 12; },
            width: function (props) { return props.checked ? 16 : 0; },
            height: function (props) { return props.checked ? 16 : 0; },
            borderRadius: "50%",
            background: function (props) { return props.disabled ? "#AAAAAA" : theme.color.primary.main; },
            content: '""',
            position: "absolute",
            transition: "all 150ms ease-in-out"
        }
    },
}); });
export var Radio = function (props) {
    var _a, _b;
    var classes = useRadioStyles({ checked: props.checked, disabled: props.disabled });
    var labelVariant = (_a = props.labelVariant) !== null && _a !== void 0 ? _a : TextVariant.s24reg;
    var limit = (_b = props.limitScaling) !== null && _b !== void 0 ? _b : false;
    return (React.createElement("div", null,
        React.createElement("label", { className: classes.label },
            React.createElement(DisplayText, { variant: labelVariant, component: "span", color: props.labelColor, limitScaling: limit }, props.labelText),
            React.createElement("input", { type: "radio", checked: props.checked, name: props.name, className: classes.input, onChange: props.onChange, value: props.value, disabled: props.disabled }),
            React.createElement("span", { className: classes.radioButton }))));
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map